import * as React from 'react';

const Bin24: React.FC<React.SVGProps<SVGSVGElement>> = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			viewBox='0 0 24 24'
			fill='none'>
			<path
				d='M13.9995 1.25C14.7287 1.25 15.4282 1.54017 15.9439 2.05566C16.4595 2.57133 16.7495 3.27075 16.7495 4V5.25H20.9995C21.4137 5.25 21.7494 5.58591 21.7495 6C21.7495 6.41421 21.4137 6.75 20.9995 6.75H19.7495V20C19.7495 20.7293 19.4596 21.4286 18.9439 21.9443C18.4281 22.46 17.7288 22.75 16.9995 22.75H6.99953C6.27035 22.7499 5.5708 22.4599 5.05519 21.9443C4.5397 21.4286 4.24953 20.7292 4.24953 20V6.75H2.99953C2.58553 6.74975 2.24953 6.41406 2.24953 6C2.24967 5.58607 2.58562 5.25025 2.99953 5.25H7.24953V4C7.2496 3.2708 7.53959 2.57132 8.05519 2.05566C8.57081 1.54005 9.27035 1.25012 9.99953 1.25H13.9995ZM5.74953 20C5.74953 20.3313 5.88155 20.6494 6.11574 20.8838C6.35005 21.1181 6.66818 21.2499 6.99953 21.25H16.9995C17.331 21.25 17.6489 21.1181 17.8833 20.8838C18.1177 20.6494 18.2495 20.3315 18.2495 20V6.75H5.74953V20ZM9.99953 10.25C10.4137 10.25 10.7494 10.5859 10.7495 11V17C10.7495 17.4142 10.4137 17.75 9.99953 17.75C9.58553 17.7497 9.24953 17.4141 9.24953 17V11C9.24967 10.5861 9.58562 10.2503 9.99953 10.25ZM13.9995 10.25C14.4137 10.25 14.7494 10.5859 14.7495 11V17C14.7495 17.4142 14.4137 17.75 13.9995 17.75C13.5855 17.7497 13.2495 17.4141 13.2495 17V11C13.2497 10.5861 13.5856 10.2503 13.9995 10.25ZM9.99953 2.75C9.66818 2.75012 9.35005 2.8819 9.11574 3.11621C8.88144 3.35056 8.7496 3.66862 8.74953 4V5.25H15.2495V4C15.2495 3.66858 15.1177 3.35057 14.8833 3.11621C14.6489 2.88202 14.3309 2.75 13.9995 2.75H9.99953Z'
				fill='#D32733'
			/>
		</svg>
	);
};

export default Bin24;

